
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leistungen",
      function () {
        return require("private-next-pages/leistungen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leistungen"])
      });
    }
  